import validator from "validator";
import { isObject } from "../utils/is-object.js";
const { isMimeType } = validator;
export function isUploadedFile(value) {
    try {
        return (isObject(value) &&
            "tmpPath" in value &&
            typeof value.tmpPath === "string" &&
            "mimeType" in value &&
            typeof value.mimeType === "string" &&
            isMimeType(value.mimeType) &&
            "name" in value &&
            typeof value.name === "string" &&
            "sizeInBytes" in value &&
            typeof value.sizeInBytes === "number" &&
            value.sizeInBytes >= 1);
    }
    catch {
        return false;
    }
}
